import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import UnitGroup from '../components/ReviewVoiceNote/UnitGroup';
import { getAllUpgradedLARForAdmin } from '../service/service';
import Layout from '../components/Layout';
import { useParams } from 'react-router-dom';

const UpgradedLARTable = () => {
  const { courseId, courseName } = useParams();
  const [voices, setVoices] = useState([]);

  const getAllVoices = async () => {
    try {
      const result = await getAllUpgradedLARForAdmin(courseId, courseName);
      setVoices(result);
    } catch (error) {
      console.log('Error', error);
    }
  };

  useEffect(() => {
    getAllVoices();
  }, []);

  const handleDelete = (voiceId) => {
    getAllVoices();
  };

  const groupedVoices = voices?.reduce((acc, voice) => {
    const { parentUnitId } = voice;
    if (!acc[parentUnitId.name]) acc[parentUnitId.name] = [];
    acc[parentUnitId.name].push(voice);
    return acc;
  }, {});

  return (
    <Layout>
      <Typography variant="h4" component="h1" sx={{ mb: 4 }}>
        Review Upgraded LAR Voice Notes Here!
      </Typography>
      {Object.keys(groupedVoices).map((unitName) => (
        <UnitGroup handleDelete={handleDelete} setVoices={setVoices} courseName={courseName} key={unitName} unitName={unitName} voices={groupedVoices[unitName]} />
      ))}
    </Layout>
  );
};

export default UpgradedLARTable; 